import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import omit from 'lodash/omit';
import { Alert } from 'localmed-core';

import { Fade, TransitionGroup } from '../Transitions';
import applyFormTheme from './applyFormTheme';
import { formThemeShape } from './PropTypes';

import style from './Field.scss';

export default class Field extends React.Component {
  static contextTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    formik: PropTypes.object,
    formTheme: formThemeShape,
  };

  render() {
    const { formTheme, formik } = this.context;
    const { children, className, name, htmlFor, showAllErrors, horizontal, ...props } = this.props;
    let { label, errors } = this.props;
    const theme = applyFormTheme(formTheme, { horizontal });
    if (errors === undefined && formik && name) {
      const touched = formik.touched[name];
      errors = !formik.isSubmitting && touched && formik.errors && formik.errors[name];
      if (errors && !showAllErrors) {
        errors = errors.slice(0, 1);
      }
    }
    const hasErrors = errors && errors.length > 0;
    if (label) {
      label = (
        // eslint-disable-next-line jsx-a11y/label-has-for
        <label htmlFor={htmlFor || name} className={style.field__label}>
          {label}
        </label>
      );
    }
    return (
      <div
        className={classNames(
          style.field,
          hasErrors && style['field--with-errors'],
          theme.horizontal && style['field--horizontal'],
          className
        )}
        {...omit(props, ['label', 'errors'])}
      >
        {label}
        <div className={style.field__body}>
          {children}
          <TransitionGroup component="ul" className="list-reset">
            {errors &&
              errors.map((error) => (
                <Fade key={error} duration={100}>
                  <li className="margin-top-xs">
                    <Alert tier="error" subtle fontSize="xs">
                      {error}
                    </Alert>
                  </li>
                </Fade>
              ))}
          </TransitionGroup>
        </div>
      </div>
    );
  }
}
